module.exports = __webpack_public_path__ + "static/media/cnito_live_bg_tablet.e93bf175.svg";